import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

import { APP } from 'src/Configs/App'
import { ErrorCode, NameSpace } from 'src/Redux/types'
import { api } from 'src/Services/api'
import { TikTokCampaignPricingModelEnum } from 'src/Types/campaigns'

interface GetAudienceTiktokParams {
  amount: number
  pricingModel: TikTokCampaignPricingModelEnum
}

export interface GetAudienceTiktokResponse {
  price: number
  pricingModel: TikTokCampaignPricingModelEnum
  videos: { min: number; max: number }
  viewsMedian: { min: string; max: string }
}

export const getAudienceTiktok = createAsyncThunk<
  GetAudienceTiktokResponse,
  GetAudienceTiktokParams
>(
  `${NameSpace.AudienceTiktok}/getAudienceTiktok`,
  async ({ amount, pricingModel }, { rejectWithValue }) => {
    try {
      const { data } = await api.get<GetAudienceTiktokResponse>(
        `${APP.TIKTOK_SERVER}/artist/tiktok/expected-reach/?amount=${amount}&pricingModel=${pricingModel}`,
      )
      return data
    } catch (error) {
      const { response } = error as AxiosError<{ message: string }>
      return rejectWithValue({
        message: response?.data.message,
        code: response?.status || ErrorCode.InternalServerError,
      })
    }
  },
)
